/* import __COLOCATED_TEMPLATE__ from './card.hbs'; */
import { action } from '@ember/object';
import { error } from 'client-portal/utils/banners';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import { isImage } from 'client-portal/utils/file';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import Component from '@glimmer/component';

export default class SiteDocumentsContactInfoPhotoIdSectionCard extends Component {
  @service store;
  @service analytics;
  @service intl;
  @service media;

  get photoIds() {
    return this.args.demographicsForm.connection.photoIds;
  }

  get mappedField() {
    return this.args.path;
  }

  get cardTitle() {
    const side = this.intl.t(
      `site.documents.contactInfo.photoIdSection.${this.args.side.toLowerCase()}`
    );
    const ofPhotoId = this.intl.t('site.documents.contactInfo.photoIdSection.ofPhotoId');
    return `${side} ${ofPhotoId}`;
  }

  get model() {
    let id = this.args.demographicsForm.connection[this.mappedField];
    return this.photoIds.find(({ id: photoId }) => photoId === id?.toString());
  }

  get isImageFile() {
    return isImage(this.model);
  }

  get fileUrl() {
    if (this.model?.id) {
      if (isEmberTesting()) {
        return '/test-fixtures/test-logo.png';
      }

      let adapter = this.store.adapterFor('photo-id');
      return adapter.urlForFindRecord(this.model.id, 'photo-id', {});
    }

    return undefined;
  }

  @action
  async remove() {
    await this.model.destroyRecord();
    this.args.demographicsForm.connection.set(this.mappedField, null);
    this.args.demographicsForm.set(this.mappedField, null);
  }

  async _performUpload(file) {
    try {
      let photoId = await this.store
        .createRecord('photo-id', {
          file,
          connection: this.args.demographicsForm.connection,
        })
        .save();

      this.analytics.track('Photo ID Uploaded', {
        object: 'Photo ID',
        action: 'Uploaded',
        source: window.navigator.userAgent,
        'object_id': photoId.id,
        'card_type': `${this.args.side} of Photo ID`,
        'client_profile_page': false,
      });

      this.args.demographicsForm.connection.set(this.mappedField, photoId.id);
      this.args.demographicsForm.set(this.mappedField, photoId.id?.toString());
    } catch (err) {
      error({ title: this.intl.t('messages.error.fileNotUploaded') });
    }
  }

  @(task(function* (file) {
    yield this._performUpload(file);
  }).drop())
  uploadCard;
}
